








import Vue from "vue";
import UsageHistoryTable from "@/components/organisms/UsageHistoryTable/index.vue";

export default Vue.extend({
  components: { UsageHistoryTable },
  props: {
    data: Array,
  },
  data() {
    return {};
  },
  methods: {
    handleOnSearch(val: any) {
      this.$emit("getUsageHistory", val);
    },
  },
});
